/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */

// Imports from generateWebWorker.js for app build otherwise generatorPromise.js
import sendData from '_APIC_DATA_SENDER_';

class Generator {
  async generateDummyValue(
    valueConfig = {
      propertyName: '',
      property: {},
      empty: false
    }
  ) {
    return sendData({
      ...valueConfig,
      type: 'value'
    });
  }

  async generateExampleParameter(
    parameterConfig = {
      api: {},
      pathName: '',
      verb: '',
      parameter: {},
      contentTypeHeader: '',
      skipBeautify: false,
      maxDepth: 5,
      references: [],
      numItems: 1
    }
  ) {
    return sendData({
      ...parameterConfig,
      type: 'parameter'
    });
  }

  async generateExampleResponse(
    responseConfig = {
      api: {},
      path: '',
      verb: '',
      response: '',
      contentType: '',
      config: {},
      maxDepth: 5,
      references: [],
      numItems: 1
    }
  ) {
    return sendData({
      ...responseConfig,
      type: responseConfig.api.openapi ? 'oai3response' : 'response'
    });
  }

  async generateWebhookExampleParameter(
    responseConfig = {
      api: {},
      schema: {},
      contentType: '',
      highlight: true
    }
  ) {
    return sendData({
      ...responseConfig,
      type: 'oai31response'
    });
  }

  async generateAsyncApiResponse(
    responseConfig = {
      api: {},
      schema: {},
      contentType: '',
      highlight: true
    }
  ) {
    return sendData({
      ...responseConfig,
      type: 'eventResponse'
    });
  }

  // generate flattened schema with resolved references
  // returns Promise that resolves with the resolved references
  async generateFlattenedSchema(definitions = {}) {
    // use worker to resolve references, needs object of the schema with definitions as a property
    // so it can resolve #/definitions/address for example
    const data = await sendData({
      schema: definitions,
      type: 'resolveReferences'
    });
    return data.schema;
  }
}

export default new Generator();
